export enum ConnectionType {
  OAUTH2_AUTHORIZATION_CODE = "OAUTH2_AUTHORIZATION_CODE",
  OAUTH2_CLIENT_CREDENTIALS = "OAUTH2_CLIENT_CREDENTIALS",
  API_KEY = "API_KEY",
}

export enum OAuth2AuthorizationMethod {
  HEADER = "HEADER",
  BODY = "BODY",
}

export enum OAuth2GrantType {
  AUTHORIZATION_CODE = "authorization_code",
  CLIENT_CREDENTIALS = "client_credentials",
  REFRESH_TOKEN = "refresh_token",
}

export type AfterTokenExchangeArgs = {
  accessToken: string;
  refreshToken?: string;
  accountId: string;
  inputValues?: Record<string, string>;
  callbackQueryParams?: Record<string, string>;
};

export type AfterTokenExchangeResponse = Record<string, unknown> | undefined;

export interface ConnectionDisplayMetadata {
  /** Labels for input fields, keyed by inputValues field name (e.g. "clientId", "apiKey"). Defaults are set per connection type. */
  inputLabels?: Record<string, string>;
  helpText?: string;
  helpUrl?: string;
  helpUrlText?: string;
}

// These workflows are triggered after the connection is created.
// This allows us to backfill data and register webhooks.
export interface ConnectionWorkflows {
  backwardSyncWorkflow?: string;
  registerWebhookWorkflow?: string;
  deregisterWebhookWorkflow?: string;
}
